<template>
    <v-data-table :headers="headers" :items="bestaetigungen.spieler" hide-default-footer mobile-breakpoint="1"
                 :items-per-page="-1">
        <template v-slot:no-data>
            <span v-if="!bestaetigungen.selectedVerbandId || !bestaetigungen.selectedVereinId">
                Bitte Landesverband und Verein wählen!
            </span>
            <span v-else>
                Es wurden keine Daten gefunden
            </span>
        </template>
        <template v-slot:item.dsv={item}>
            <span class="text-no-wrap">{{ item.dsv }}</span>
        </template>
        <template v-slot:item.ade={item}>
            <span class="text-no-wrap">{{ item.ade }}</span>
        </template>
        <template v-slot:item.attest={item}>
            <span class="text-no-wrap">{{ item.attest }}</span>
        </template>
    </v-data-table>
</template>

<script>
export default {
    name: "bestaetigungenListe",
    props: ['bestaetigungen'],
    data: () => ({
        headers: [
            {text: 'Nachname', value: 'nachname', sortable: false},
            {text: 'Vorname', value: 'vorname', sortable: false},
            {text: 'PassNr', value: 'passNr', sortable: false},
            {text: 'Altersklasse', value: 'ak', sortable: false},
            {text: 'DSV', value: 'dsv', sortable: false},
            {text: 'ADE', value: 'ade', sortable: false},
            {text: 'Ärztl. Attest gültig bis', value: 'attest', sortable: false},
        ]
    }),
}
</script>

<style scoped>

</style>